import { render, staticRenderFns } from "./SalesOrderChange.vue?vue&type=template&id=1365980e&"
import script from "./SalesOrderChange.vue?vue&type=script&lang=js&"
export * from "./SalesOrderChange.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderChange.vue?vue&type=style&index=0&id=1365980e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports